<template>
  <div class="password-input">
    <BaseInput :label="label"
               :type="computedType"
               v-model="val"
               v-bind="attrs"
               :class="{'--error':error}"
               v-on="listeners">
      <template v-slot:errors="">
        <slot name="errors"></slot>
      </template>
    </BaseInput>
    <IconEye v-if="passwordReveal" @click.native="passwordRevealed = !passwordRevealed" class="icon-reveal"/>
  </div>
</template>

<script>
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import IconEye from "@/components/icons/IconEye";

export default {
  inheritAttrs:false,
  name: "PasswordInput",
  components: {IconEye, BaseInput},
  props: {
    label: {
      type: String,
      default: null
    },
    passwordReveal: {
      type: Boolean
    },
    value: {
      required: true
    },
    error:{
      type:Boolean
    }
  },
  data() {
    return {
      passwordRevealed: false
    }
  },
  computed: {
    computedType() {
      return this.passwordRevealed ? 'text' : 'password'
    },
    val: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    attrs(){
      return {...this.$attrs}
    },
    listeners() {
      return {...this.$listeners}
    }
  },
  methods: {
    toggleRevealPassword() {
      this.passwordRevealed = !this.passwordRevealed;
    }
  }
}
</script>

<style scoped lang="scss">
.password-input {
  @apply relative;
  .icon-reveal {
    @apply text-icon absolute cursor-pointer;
    transition: all .2s;
    top: 50%;
    right: 1.6rem;
    transform: translateY(-50%);

    &:hover {
      @apply text-icon-hover;
    }
  }
}
</style>